export default function httpError(state = {}, action) {
  if (action.type === "SHOW_HTTP_ERROR") {
    const { name, errorCode, config = {}, id='' } = action;
    const nextState = { ...state };
    if (!nextState[name]) {
      nextState[name] = {
        name,
        errorCode,
        state: config.state,
        id
      };
      return nextState;
    }
  } else if (action.type === 'HIDE_HTTP_ERROR') {
    const { name } = action;
    const nextState = { ...state };
    if (nextState[name]) {
      delete nextState[name];
      return nextState;
    }
  } else if (action.type === 'FLAT_ERROR_OBJECT') {
    return { ...state, error: action.error };
  }

  return state;
}
